import { isInOutsideH5 } from '@fs/utils'
import { getLogoutInstance, invokeToast } from '../http.tool'
import { t } from '../i18n/t.js'
import pathnames from '../config/EsopH5Pathname.js'
import { isComplianceAuditFlow } from '@repo/common-utils/utils/complianceSession'
import { clearUcAndSkillhubLeadStorage } from '@repo/common-utils/utils/ucSessionAndLeadStorage'
import goto, { getUrlParams } from '@repo/common-utils/utils/goto'

const { VUE_MEMBER_H5 } = pathnames

/** 仅 Skill 嵌入页：会话失效不跳 H5 统一登录、不全量 clear localStorage，避免与站内注销/主题等冲突。 */
function isSkillHubAppShell() {
  if (import.meta.env?.VUE_APP_IS_SKILLHUB === 'true' || import.meta.env?.VITE_IS_SKILLHUB === '1') {
    return true
  }
  if (typeof window === 'undefined' || !window.location) return false
  const pathname = window.location.pathname
  const base = import.meta.env?.VITE_APP_BASE || import.meta.env?.VUE_APP_BASE
  if (base) {
    const seg = String(base).replace(/^\//, '').replace(/\/$/, '')
    if (seg && pathname.includes(seg)) return true
  }
  return pathname.includes('finSkillHub')
}

export default (response) => {
  if (isInOutsideH5()) {
    if (typeof window !== 'undefined' && window.location?.href?.includes('tradeRecom')) return response
    console.log('outsideH5LogoutInterceptor => ', response)
    console.log('outsideH5LogoutInterceptor => ', response.data?.error?.code)
    switch (response.data?.error?.code) {
      case 100034:
        // 互踢弹窗
        getLogoutInstance().open()
        return Promise.reject(response)
      case 100008:
      case 100031:
      case 100033: {
        const isSkill = isSkillHubAppShell()
        if (isSkill) {
          clearUcAndSkillhubLeadStorage()
          return Promise.reject(response)
        }

        const isEsopApi = response?.config?.url?.indexOf('/esop/') !== -1
        console.log('outsideH5LogoutInterceptor isEsopApi = ', isEsopApi)

        // 检查是否为合规出入金场景，如果是则不显示错误提示
        const isCompliance = isComplianceAuditFlow()
        const isUserDetailApi = response?.config?.url?.includes('/uc/v1/UserDetail')

        // 只有在非合规场景或非UserDetail接口时才显示Toast
        if (!(isCompliance && isUserDetailApi)) {
          const message = t('requestCode.dlsxqcxdl')
          invokeToast({
            forbidClick: true,
            message: message,
          })
        } else {
          console.log('合规出入金场景下的 UserDetail 接口登录失效，跳过Toast提示')
        }
        globalThis.localStorage?.clear()

        // 合规出入金场景下不执行定时器跳转
        const query = getUrlParams()
        const pageHref = typeof window !== 'undefined' ? window.location?.href : ''
        if (!(isCompliance && isUserDetailApi)) {
          globalThis.setTimeout(() => {
            if (isEsopApi) {
              goto(VUE_MEMBER_H5)
            } else {
              goto('login', {
                query: {
                  path: decodeURIComponent(pageHref),
                  ...query,
                },
              })
            }
          }, 2000)
        } else {
          if (isEsopApi) {
            goto(VUE_MEMBER_H5)
          } else {
            goto('login', {
              query: {
                path: decodeURIComponent(pageHref),
                ...query,
              },
            })
          }
        }

        return Promise.reject(response)
      }
      default:
        break
    }
  }
  return response
}
